import React, { useState } from 'react';
import {
  Modal,
  View,
  TouchableWithoutFeedback,
  Linking,
  Platform,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import {
  Description,
  HowItWorksTitle,
  Container,
  ModalOverlay,
  ModalContent,
  Header,
  HeaderTitle,
  CloseButton,
  CloseButtonText,
  List,
  Bold,
  Footer,
  ThumbButton,
  ThumbImage,
  ModalBody,
} from './styles';
import {Titles} from '../../Interface/Typographies/Titles';
import {StepList} from '../../Interface/List/StepList';
import {Button} from '../../Interface/Forms/Buttons/Button';

import thumbImage from '../../../assets/images/banners/thumb-gire.webp'
import { HelpVideo } from '../HelpVideo';
interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function RouletteBottomSheet({isOpen, onClose}: Props) {
    
  const [showVideo, setShowVideo] = useState(false);

  return (
    <Modal visible={isOpen} onRequestClose={onClose} transparent animationType='fade'> 
      <ModalOverlay>
        <TouchableWithoutFeedback onPress={onClose}>
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          />
        </TouchableWithoutFeedback>
        <ModalContent>
                
            <Container>
              
              <ThumbButton activeOpacity={0.7} onPress={() => setShowVideo(true)} >
                
                <ThumbImage source={thumbImage} resizeMode="cover">
                  <Header>
                 
              <CloseButton onPress={onClose}>
                <CloseButtonText>✕</CloseButtonText>
              </CloseButton>
              </Header>
                  <HeaderTitle>Gire e ganhe</HeaderTitle>
                  </ThumbImage>
              </ThumbButton>

<ModalBody>

                <Titles
                title="Sobre o gire e ganhe"
                subtitle='Sua sorte está no Baratão! Gire a roleta todos os dias e concorra a BaratinhaZ, cupons exclusivos e descontos no combustível!
'
              />
             

              

            <List>
              <HowItWorksTitle>Como funciona?</HowItWorksTitle>
                <StepList
                  number={1}
                  text='Toque no botão "Girar" e cruze os dedos! A roleta irá sortear seu prêmio em tempo real.'
                />
                <StepList
                  number={2}
                  text="Recebeu BaratinhaZ? Vão direto para sua carteira."
                />
                <StepList
                  number={3}
                  text="Ganhou cupom de desconto? Use-o no seu próximo abastecimento!"
                />
              </List>

             
</ModalBody>
              
            </Container>

             <Footer>
               <Button
                title="Ok, entendi"
                onPress={() =>
                 onClose()
                }
                enabled
              />

            </Footer>
           
        </ModalContent>

      </ModalOverlay>
     {
              showVideo && (<HelpVideo videoURI='https://d3ag5cip9ldvh3.cloudfront.net/GIREGANHE.MP4' onVideoEnd={() => setShowVideo(false)}/>)
            }
    </Modal>
  );
}
